import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HeroStackThankYou from "@/pages/lp/HeroStackThankYou";

export const Route = createFileRoute("/lp/hero-stack/thank-you")({
  head: () => seoHead("/lp/hero-stack/thank-you"),
  component: HeroStackThankYou,
});
